import { useNavigate, useParams } from 'react-router-dom'
import { capitalize } from 'lodash'
import { useTranslation } from 'react-i18next'
import { Box, Drawer } from '@mui/material'
import { BasePathProvider, EmploymentTypeProvider } from 'components/Providers'
import MemberSearch from './Search'
import Person from './Person'
import PageHeader from 'components/AppBar/PageHeader'

function Member() {
  const navigate = useNavigate()
  const { employmentType, memberId, } = useParams()
  const { t } = useTranslation()
  const basePath = `/member/${employmentType}`

  if (employmentType !== 'student' && employmentType !== 'staff') {
    navigate('/')
  }
  return (
    <BasePathProvider value={basePath}>
      <EmploymentTypeProvider type={employmentType}>
        <Box sx={{ pb: 2 }}>
          <PageHeader title={t(`${capitalize(employmentType)} List`)} add />
        </Box>
        <MemberSearch />
        <Drawer open={Boolean(memberId)} anchor="right" onClose={() => navigate(basePath)}>
          <Person />
        </Drawer>
      </EmploymentTypeProvider>
    </BasePathProvider>
  )
}

export default Member
